import Styles from './Prompt.module.scss'

const BOTTOM_PADDING = 5
const RIGHT_PADDING = 5

export const adjustHorizontalPosition = (wrapper: HTMLElement, position: { left: number }) => {
  const container = getContainer(wrapper)

  if (container) {
    const box = container.getBoundingClientRect()
    const embedElement = document.querySelector<HTMLElement>(`.${Styles.mediaUploadContainer}`)

    if (embedElement) {
      const embed = embedElement.getBoundingClientRect()

      if (embed.width + position.left > box.width) {
        const left = box.width - embed.width - RIGHT_PADDING
        wrapper.style.left = `${left}px`
      }
    }
  }
}

export const adjustSidebarMaxHeight = (wrapper: HTMLElement, position: { top: number }) => {
  const container = getContainer(wrapper)

  if (container) {
    const box = container.getBoundingClientRect()
    const sidebarElement = document.querySelector<HTMLElement>(`.${Styles.mediaUploadSidebar}`)

    if (sidebarElement) {
      const sidebar = sidebarElement.getBoundingClientRect()

      if (sidebar.height + position.top > box.height) {
        const maxHeightToAvoidOverflow = box.height - position.top - BOTTOM_PADDING
        sidebarElement.style.maxHeight = `${maxHeightToAvoidOverflow}px`
      }
    }
  }
}

export const adjustPreviewMaxHeight = (wrapper: HTMLElement, position: { top: number }) => {
  const container = getContainer(wrapper)

  if (container) {
    const box = container.getBoundingClientRect()
    const previewElement = document.querySelector<HTMLElement>(`.${Styles.previewContainer}`)

    if (previewElement) {
      const preview = previewElement.getBoundingClientRect()

      const headerAndFooterHeight = divHeight(`.${Styles.headerWrapper}`) + divHeight(`.${Styles.footerWrapper}`)
      const rightDivTotalHeight = preview.height + headerAndFooterHeight

      if (rightDivTotalHeight + position.top > box.height) {
        const maxHeightToAvoidOverflow = box.height - position.top - headerAndFooterHeight - BOTTOM_PADDING
        previewElement.style.maxHeight = `${maxHeightToAvoidOverflow}px`
      }
    }
  }
}

const getContainer = (element: HTMLElement) => {
  // Workaround due to Firefox:
  // element.offsetParent returns null when element has the position property set to fixed
  // BUT firefox returns <body>
  //
  // (documentation: https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent)
  //
  // Here element could have `position: fixed`, and in this case, we do want the <body> as the container.
  // The following 2 lines make it browser agnostic:
  const elementIsFixed = window.getComputedStyle(element).position === 'fixed'
  return elementIsFixed ? document.body : element.offsetParent
}

const divHeight = (selector: string): number => {
  const element = document.querySelector<HTMLElement>(selector)

  if (!element) return 0

  const styles = window.getComputedStyle(element)

  const height = element.getBoundingClientRect().height
  const marginTop = parseFloat(styles.getPropertyValue('margin-top'))
  const marginBottom = parseFloat(styles.getPropertyValue('margin-bottom'))

  return height + marginTop + marginBottom
}
